import React, {createContext, ReactNode, useContext, useState} from "react";
import { Spinner } from "react-bootstrap";

interface LoadingContextType{
    isLoading: boolean;
    showLoading: () => void;
    hideLoading: () => void;
}

const LoadingContext = createContext<LoadingContextType | undefined>(undefined);
export const useLoading = (): LoadingContextType => {
    const context = useContext(LoadingContext);
    if(!context){
        throw new Error('useLoading must be used within a LoadingProvider');
    }
    return context;
}

interface LoadingProviderProps{
    children: ReactNode;
}

export const LoadingProvider: React.FC<LoadingProviderProps> = ({ children }) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const showLoading = () => setIsLoading(true);
    const hideLoading = () => setIsLoading(false);
    return (
        <LoadingContext.Provider value={{ isLoading, showLoading, hideLoading }}>
            {children}
            {isLoading && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1000,
                }}>
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>
            )}
        </LoadingContext.Provider>
    );
      

};